import { useCallback, useContext, useState } from 'react';

import { BookmarkContext, loginConfig, PageNavigationContext, SavedSearchContext } from '../../context';
import { saveUserData } from '../../utils';
import { useCockpitAccess } from '..';

export const useCockpitRedirectDialog = (): {
  onSave: () => void;
  onRedirect: () => void;
  onClose: () => void;
  isOpen: boolean;
  isDisabled: boolean;
} => {
  const { bankCodeUrl } = useCockpitAccess();
  const { bookmarks } = useContext(BookmarkContext);
  const { savedSearches } = useContext(SavedSearchContext);
  const navigate = useContext(PageNavigationContext);

  const [isSaving, setIsSaving] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState<string | null>(null);

  const enableSaveUserData = Boolean(loginConfig?.userApiUrl && (bookmarks.length > 0 || savedSearches.length > 0));
  const isDisabled = !enableSaveUserData || isSaving;

  const handleSaveUserData = useCallback(async () => {
    const payload = {
      estateBookmarks: bookmarks,
      searchAgents: savedSearches.map((s) => s.searchParams),
    };
    return saveUserData(loginConfig.userApiUrl, payload);
  }, [bookmarks, savedSearches]);

  const onSave = useCallback(async () => {
    if (isDisabled) {
      return;
    }
    setIsSaving(true);
    const key = await handleSaveUserData();
    setIsSaving(false);

    if (!key) {
      return;
    }
    setRedirectUrl(`${bankCodeUrl}/cockpit-immobilie?ifa=sipuserkey:${key}`);
    setIsOpen(true);
  }, [isDisabled, handleSaveUserData, bankCodeUrl]);

  const onClose = useCallback(() => {
    setIsOpen(false);
    setRedirectUrl(null);
  }, []);

  const onRedirect = useCallback(() => {
    if (redirectUrl) {
      navigate(redirectUrl);
    }
  }, [navigate, redirectUrl]);

  return { onSave, onRedirect, onClose, isOpen, isDisabled };
};
